import { app } from '../../../../../bootstrap/core';
import { successfulConfirmState } from './successfulConfirm.state';
import { successfulConfirmComponent } from './successfulConfirm.component';

app.config(successfulConfirmState);
app.component(successfulConfirmComponent.name, successfulConfirmComponent);
